$.namespace("common.link");
common.link = {
    /**
     * 메인 이동
     */
    moveMainHome : function(amplitudeParamString) {
        location.href = _plainUrl + "main/main.do"+ (amplitudeParamString ? ("?"+amplitudeParamString) : "");
    },

    /**
     * 오늘드림 이동
     */
    moveQuick : function() {
        location.href = _plainUrl + "main/getQuickMainList.do";
    },
    /**
     * 기프트관이동
     */
    moveGift : function(gateCd) {
        common.giftClickEvent();
        location.href = _plainUrl + "mtn/gift" + (gateCd ? "?gateCd=" + gateCd : "");
    },
    /**
     * 기프트카드 안내페이지 이동
     */
    moveGiftCardGuide : function(gateCd) {
        common.wlog("giftcard_mobile_drawer_param");
        common.giftCardClickEvent();
        location.href = _plainUrl + "giftCardGuide/getGiftCardGuide.do" + (gateCd ? "?gateCd=" + gateCd : "");
    },
    /**
     * 세일 이동
     */
    moveSale : function() {
        location.href = _plainUrl + "main/getSaleList.do";
    },

    /**
     *  멤버십/쿠폰 이동
     */
    moveMembership : function(callLog) {
        if(callLog){
            var params = "";
            try {
                params = "?" + getEventParameterString({'t_page':'마이페이지','t_click':"멤버십라운지_이동"});
            }catch (e) { void 0; params="";}
            location.href = _plainUrl + "main/getMembership.do"+params;
        }else{
            location.href = _plainUrl + "main/getMembership.do";
        }
    },

    /**
     *  쿠폰/멤버십 이동
     */
    moveCoupon : function(params) {
        if (params === undefined || params == null || params === "") {
            try {
                params = "?" + getEventParameterString({'t_page':'멤버십혜택','t_click':"쿠폰_이동"});
            }catch (e) { void 0; params="";}
        }
        location.href = _plainUrl + "main/getCouponList.do"+params;
    },

    /**
     *  쿠폰존 이동
     */
    moveCouponZone : function() {
        //location.href = _plainUrl + "mypage/getCouponList.do";
        location.href = _plainUrl + "main/getCouponList.do";
    },

    /**
     *  멤버십 등급별 혜택 이동
     */
    getMembershipBenefitInfoMoveUrl : function() {
        location.href = _plainUrl + "main/getMembershipBenefitInfo.do";
    },

    /**
     *  탑리뷰어 이동
     */
    //! TODO: review
    moveTopReviewer : function(amplitudeParamString) {
        if (amplitudeParamString) {
            location.href = _plainUrl +"mypage/getReviewerLounge.do?" + amplitudeParamString;
        } else {
            location.href = _plainUrl +"mypage/getReviewerLounge.do";
        }

    },

    /**
     *  올영체험단 이동
     */
    moveOllyoung : function() {
        location.href = _plainUrl +"main/getOllyoungList.do";
    },

    /**
     *  마이페이지 정보수정 이동
     */
    moveMyPageSetting : function() {
        var tPage = "멤버십라운지";
        var tClick = "혜택알림받기";
        callLogEvent("멤버십라운지_혜택알림받기 클릭",  {entry_source: tPage, click_source: tClick});
        this.moveSettingAtPush( getEventParameterString( {t_page: tPage, t_click: tClick}) , false);
    },

    /**
     *  올영체험단 리뷰페이지 이동
     */
    moveMyPageOllyoungList : function() {
        location.href = _plainUrl + "mypage/getMyOllyoungList.do";
//      location.href = _plainUrl + "mypage/getMyBeautyList.do";

    },

    /**
     * 올영체험단 리뷰 작성 이동
     */
    moveMyOllyoungWritePage : function(evtNo,goodsNo,gdasSeq,retUrl) {
        location.href = _plainUrl + "mypage/getGdasEvalForm.do?evtNo="+evtNo+"&goodsNo="+goodsNo+"&gdasSeq="+gdasSeq+"&gdasTpCd=30&gdasSctCd=50&gdasStep=1&retUrl="+retUrl;
    },


    /**
     *  배송지/환불계좌 관리 이동
     */
    moveMyPageDeliveryInfo : function() {
        location.href = _plainUrl + "mypage/getDeliveryInfo.do";
    },

    /**
     *  트렌드 이동
     */
    moveTrend : function() {
        location.href = _plainUrl + "main/getThemeList.do";
    },

    /**
     * 마이페이지 메인 이동
     */
    moveMyPageMain : function(amplitudeParamString) {
        location.href = _plainUrl + "mypage/myPageMain.do"+ (amplitudeParamString ? ("?"+amplitudeParamString) : "");
    },

    /**
     * 상품상세 이동
     */
    moveGoodsDetail : function(goodsNo, dispCatNo, trackingCd, rcCode, gateCd, amplitudeObject) {
        var param = "?goodsNo=" + goodsNo;
        var giftSearchThemeFlag = trackingCd == null || trackingCd.indexOf("Gift_Search_Theme") < 0 ? false : true;
        if (!common.isEmpty(dispCatNo) && dispCatNo != "orderImg" && dispCatNo != "orderName" && dispCatNo != "oftenGoods") {
            param = param + "&dispCatNo=" + dispCatNo;
            if('90000080001' == dispCatNo){
                if (!common.isEmpty(trackingCd)) {
                    param = param + "&trackingCd="+trackingCd;
                }
                if (!common.isEmpty(rcCode)) {
                	param = param + "&rccode="+rcCode;
                }
            }else{
            	if(trackingCd!=null && trackingCd!=undefined){
            		param = param + "&trackingCd="+trackingCd;
            	}
            }
        }else{
        	if(trackingCd!=null && trackingCd!=undefined){
        		param = param + "&trackingCd="+trackingCd;
        	}

        	// 마이페이지 장바구기 담기 DS 추가로 분기 처리 - [3330196] 올리브영 모바일 주문목록 개선 요청(CHY)
        	if(dispCatNo == "orderImg"){
        		common.wlog("mypage_orderlist_themimg");
        	}else if(dispCatNo == "orderName"){
        		common.wlog("mypage_orderlist_goodsNm");
        	}else if(dispCatNo == "oftenGoods"){
        		$(".swiper-slide > div > a").each(function(idx) {
        			$(this).bind("click", function() {
        				common.wlog("mypage_oftenlist_goods" + (idx + 1));
        			});
        		});

        		$(".swiper-slide .info > a").each(function(idx) {
        			$(this).bind("click", function() {
        				common.wlog("mypage_oftenlist_goods" + (idx + 1));
        			});
        		});
        	}
        }
        if (!!gateCd) param = param + "&gateCd=" + gateCd;
        if (!common.isEmpty(amplitudeObject)) {
            param += ('&' + getEventParameterString(amplitudeObject));
        }

        // 카테고리관 몰로코 상품(trackingCd : MolocoAd 문자 포함)이 아닌 일반 상품리스트 클릭한 경우
        if ($("#categoryShop_small_name").length != 0 && !trackingCd.includes("MolocoAd")) {
            let categoryNo = $("#dispCatNo").val();
            let entrySourceName = "카테고리관";
            if (categoryNo.startsWith("200000")) {
                entrySourceName = "H_카테고리관";
            } else if (categoryNo.startsWith("300000")) {
                entrySourceName = "럭스에딧_카테고리관";
            }

            var categoryAmplitudeData = {};
            categoryAmplitudeData["entry_source"] = entrySourceName;
            categoryAmplitudeData["click_source"] = "전체상품";
            categoryAmplitudeData["source_number"] = Number(amplitudeObject["t_number"]);
            categoryAmplitudeData["product_number"] = goodsNo;
            categoryAmplitudeData["product_name"] = amplitudeObject["t_product_name"];
            categoryAmplitudeData["filter_type"] = $(".btn-select-toggle").text();
            categoryAmplitudeData["1st_category"] = $("#categoryShop_large_name").val();
            categoryAmplitudeData["2nd_category"] = $("#categoryShop_middle_name").val();
            categoryAmplitudeData["3rd_category"] = $("#categoryShop_small_name").val();

            callLogEvent("카테고리관_전체 상품 클릭", categoryAmplitudeData);
        }

        location.href = _plainUrl + "goods/getGoodsDetail.do" + param;
    },

    /**
     * curation 상품상세 이동
     * trackingCd 변수 추가 - [3389141] (영역별 매출분석) 오특, 검색, 베스트, 메인 추가(CHY)
     */
    moveGoodsDetailCuration : function(goodsNo , dispCatNo, curation, rccode,egcode, egrank, utmSource, utmMedium, utmCampaign, utmContent, trackingCd, amplitudeObject, gateCd) {
        var param = "?goodsNo=" + goodsNo;
        if (curation == 'store_recomm_pop') {
            var storeNo = $('input[id=strNo]').val();
            var storeNm = $('.popTitle.alignLeft').text();
            sessionStorage.setItem("storeNo", storeNo);
            sessionStorage.setItem("storeNm", storeNm);
        }

        if (!common.isEmpty(dispCatNo)) {
            param = param + "&dispCatNo=" + dispCatNo;
        }
        if (!common.isEmpty(curation)) {
            param = param + "&curation=" + curation;
        }
        if (!common.isEmpty(rccode)) {
            param = param + "&rccode=" + rccode;
        }
        if (!common.isEmpty(utmSource)) {
            param = param + "&utm_source=" + utmSource;
        }
        if (!common.isEmpty(utmMedium)) {
            param = param + "&utm_medium=" + utmMedium;
        }
        if (!common.isEmpty(utmCampaign)) {
            param = param + "&utm_campaign=" + utmCampaign;
        }
        if (!common.isEmpty(utmContent)) {
            param = param + "&utm_content=" + utmContent;
        }
        if (!common.isEmpty(egcode)) {
            param = param + "&egcode=" + egcode;
        }
        if (!common.isEmpty(egrank)) {
            param = param + "&egrankcode=" + egrank;
        }
        if (!common.isEmpty(trackingCd)) {
            param = param + "&trackingCd=" + trackingCd;
        }
        if (!common.isEmpty(amplitudeObject)) {
            if(typeof amplitudeObject === "string") {
                param = param + "&" + amplitudeObject;
            } else {
                param = param + "&" + getEventParameterString(amplitudeObject);
            }
        }
        if (!common.isEmpty(gateCd)) {
            param = param + "&gateCd=" + gateCd;
        }

        location.href = _plainUrl + "goods/getGoodsDetail.do" + param;
    },

    /**
     * curation 상품상세 바코드 이동
     */
    moveGoodsDetailBarcodeCuration : function(goodsNo, itemNo, dispCatNo, curation, rccode) {
        var param = "?goodsNo=" + goodsNo;
        if (!common.isEmpty(dispCatNo)) {
            param = param + "&itemNo=" + itemNo;
            param = param + "&dispCatNo=" + dispCatNo;
            param = param + "&curation=" + curation;
            param = param + "&rccode=" + rccode;
        }
        location.href = _plainUrl + "goods/getGoodsDetailBarcode.do" + param;
    },

    /**
     * 상품상세(바코드) 이동
     */
    moveGoodsDetailBarcode : function(mastLgcGoodsNo) {
        var param = "?itemNo=" + mastLgcGoodsNo;
        location.href = _plainUrl + "goods/getGoodsDetailBarcode.do" + param;
    },

    /**
     * 기획전/전문관 카테고리로 이동
     * @param dispCatNo {string} 전시 카테고리 번호
     * @param trackingCd {string} 트래킹 코드 - [3389141] (영역별 매출분석) 오특, 검색, 베스트, 메인 추가(CHY)
     * @param amplitudeParam {string} 앰플리튜드 파라메터
     */
    movePlanShop : function(dispCatNo, trackingCd, amplitudeParam = "") {
        var planshopUrl =  _plainUrl + "planshop/getPlanShopDetail.do";
        var queryParameter = "";
        var queryParamList = [];

        if(common.isEmpty(dispCatNo)) {
            void 0;
            return;
        } else {
            queryParamList.push("dispCatNo=" + dispCatNo);
        }

        if (!common.isEmpty(trackingCd)) {
            var targetTrackingCd = common.cart.urlParams().trackingCd || trackingCd;
            queryParamList.push("trackingCd=" + targetTrackingCd);
        }

        if(!common.isEmpty(amplitudeParam)) {
            queryParamList.push(amplitudeParam);
        }

        if (-1 < location.href.indexOf('/m/main/main.do') && -1 < location.hash.indexOf('#4')) {
            queryParamList.push("gateCd=Main");
        }

        if(queryParamList.length > 0) {
            planshopUrl += "?" + queryParamList.join("&");
        }


        location.href = planshopUrl;
    },
    /**
     * 신규 기획전 개편 상세 또는 기존 기획전 이동
     * @param dispCatNo {string} 전시 카테고리 번호
     * @param trackingCd {string} 트래킹 코드
     * @param amplitudeParam {string} 앰플리튜드 파라메터
     */
    moveS3PlanShop : function(dispCatNo, trackingCd, amplitudeParam = "") {
        var isS3Planshop = dispCatNo.substring(0, 11) === "50000010001";
        if(!isS3Planshop) {
            common.link.movePlanShop(dispCatNo, trackingCd, amplitudeParam);
            return;
        }

        var planshopUrl = _plainUrl + `mtn/planshop/detail/${dispCatNo}`;
        var queryParamList = [];

        if (!common.isEmpty(trackingCd)) {
            var targetTrackingCd = common.cart.urlParams().trackingCd || trackingCd;
            queryParamList.push("trackingCd=" + targetTrackingCd);
        }

        if(!common.isEmpty(amplitudeParam)) {
            queryParamList.push(amplitudeParam);
        }

        if (-1 < location.href.indexOf('/m/main/main.do') && -1 < location.hash.indexOf('#4')) {
            queryParamList.push("gateCd=Main");
        }

        if(queryParamList.length > 0) {
            planshopUrl += "?" + queryParamList.join("&");
        }


        location.href = planshopUrl;
    },
    /**
     * 연관된 기획전 상세 카테고리로 이동
     */
    moveRelPlanShop : function(dispCatNo, curation) {
        location.href = _plainUrl + "planshop/getPlanShopDetail.do?dispCatNo="+dispCatNo+"&curation="+curation;
    },
    /**
     * 전문관 카테고리
     */
    moveSpcShop : function(dispCatNo, gateCd) {
        var premiumShopLink = _plainUrl + 'mtn/premiumshop?dispCatNo='+dispCatNo+(gateCd ? '&gateCd='+gateCd : '');

        location.href = premiumShopLink;
    },
    /**
     * 전문관 카테고리 with amplitude
     */
    moveLiveShop : function(params) {
      var liveshopUrl = new URL(_plainUrl + 'mtn/liveshop');
      var urlParams = liveshopUrl.searchParams;

      for (var key in params) {
        urlParams.set(key, params[key]);
      }

      location.href = liveshopUrl.href;
    },

  /**
     * 신규 온라인 몰 - 네비게이션 페이지 이동
     * @param {"category" | "brand"} tab 네비게이션 드로우 탭 키 (기본값 : "category")
     */
    moveNavigationPage: function (tab = "category") {
        var navigationLink = _plainUrl + `mtn/navigation/${tab}`;

        location.href = navigationLink;
    },
    /**
     * 럭셔리 전문관 상품 리스트로 이동
	 * SR 3344578 프리미엄관 매출 트래킹 추가
     */
    moveLuxurySpcShopGoodsList : function(dispCatNo,setNo){
        location.href = _plainUrl + "planshop/getLuxurySpcShopGoodsList.do?dispCatNo="+dispCatNo+"&setNo="+setNo+"&trackingCd=Premium_Cat_PROD";
    },

    /**
     * 브랜드관카테고리로 이동
     */
    moveBrandShop : function(onlBrndCd, trackingCd, gateCd, amplitudeObject) {
        var param = "";
        if (!common.isEmpty(trackingCd)) {
            param = "&trackingCd=" + trackingCd;
        }
        if (!common.isEmpty(gateCd)) {
            param = "&gateCd=" + gateCd;
        }
        if (amplitudeObject) {
            param += "&" + getEventParameterString(amplitudeObject);
        }
        location.href = _plainUrl + "display/getBrandShopDetail.do?onlBrndCd=" + onlBrndCd + param;
        // if (common.isEmpty(trackingCd)) {
        //     location.href = _plainUrl + "display/getBrandShopDetail.do?onlBrndCd="+onlBrndCd;
        // } else {
        //     location.href = _plainUrl + "display/getBrandShopDetail.do?onlBrndCd="+onlBrndCd+"&trackingCd="+trackingCd;
        // }
    },

    /**
     * 브랜드관카테고리로 이동 - [3343897] DS영역분석 집계 누락 확인 요청(CHY)
     */
    moveBrandShopDS : function(onlBrndCd) {
    	common.wlog("search_branddirect");
        location.href = _plainUrl + "display/getBrandShopDetail.do?onlBrndCd="+onlBrndCd;
    },

    /**
     * 베스트 하위 카테고리로 이동
     */
    moveBestCtg : function(dispCatNo) {
        location.href = _plainUrl + "main/main.do#49_" + dispCatNo;
    },

    /**
     * 이벤트 탭으로 이동
     */
    moveEventTab : function(tabNo) {
        location.href = _plainUrl + "main/main.do#43_" + tabNo;
    },

    /**
     * 전시카테고리로 이동
     */
    moveCategory : function(dispCatNo) {
        location.href = _plainUrl + "display/getCategoryList.do?dispCatNo="+dispCatNo;
    },

    /**
     * 최근본상품 목록으로 이동
     */
    moveRecentList : function(trackingCd){
        var param = "";
        if (!common.isEmpty(trackingCd)) {
            param = "?trackingCd=" + trackingCd;
        }
        location.href = _plainUrl + "mypage/getRecentList.do" + param;
    },

    /**
     * 로그인 페이지로 이동
     */
    moveLoginPage : function(authYn, redirectUrl, callPushAgrYn){
        var param = "";
        if (authYn != undefined && authYn != null && authYn != "") {
            param = "?authYn=" + authYn;
        }
        if (redirectUrl != undefined && redirectUrl != null && redirectUrl != "") {
            if (param != "") {
                param = param + "&redirectUrl=" + encodeURIComponent(redirectUrl);
            } else {
                param = "?redirectUrl=" + encodeURIComponent(redirectUrl);
            }
        }
        if(callPushAgrYn != undefined && callPushAgrYn != null && callPushAgrYn != ""){
            param = "?callPushAgrYn="+callPushAgrYn;
        }
        location.href = _secureUrl + "login/loginForm.do" + param;
    },


    /**
     * 로그인 페이지로 이동
     */
    moveLoginCurationPage : function(authYn, redirectUrl, callPushAgrYn){
        var param = "";
        if (authYn != undefined && authYn != null && authYn != "") {
            param = "?authYn=" + authYn;
        }
        if (redirectUrl != undefined && redirectUrl != null && redirectUrl != "") {
            if (param != "") {
                param = param + "&redirectUrl=" + encodeURIComponent(redirectUrl);
            } else {
                param = "?redirectUrl=" + encodeURIComponent(redirectUrl);
            }
        }
        if(callPushAgrYn != undefined && callPushAgrYn != null && callPushAgrYn != ""){
            param = "?callPushAgrYn="+callPushAgrYn;
        }
        common.wlog("home_curation_login1");
        location.href = _secureUrl + "login/loginForm.do" + param;
    },

    /**
     * 성인인증/본인인증 페이지로 이동
     */
    moveRegCertPage : function(authYn,redirectUrl){
        var param = "";
        if (authYn != undefined) {
            param = "?authYn=" + authYn;
            if (redirectUrl != undefined && redirectUrl != null && redirectUrl != "") {
                if (param != "") {
                    param = param + "&redirectUrl=" + encodeURIComponent(redirectUrl);
                } else {
                    param = "?redirectUrl=" + encodeURIComponent(redirectUrl);
                }
            }
            // [CJOYMS-5808] 임시회원: "성인인증" 네이티브 화면을 열지 않고 CJ ONE 연결 브릿지로 우회.
            // _isTempMember 미주입 페이지에서는 typeof로 회귀 없이 기존 동작 유지.
            if (typeof _isTempMember !== 'undefined' && _isTempMember == "true") {
                location.href = _secureUrl + 'login/tempMemberBridge.do?returnUrl=' + encodeURIComponent(location.href);
                return false;
            }
            if(common.app.appInfo.isapp){
                var url = _secureUrl + "customer/regCertification.do"+param;
                setTimeout(function() {
                    common.app.callOpenPage("성인인증", url, "N", "Y", "Y");
                }, 200);
                return false;
            }
        }
        location.href = _secureUrl + "customer/regCertification.do" + param;
    },

    /**
     * 로그아웃 페이지로 이동
     */
    moveLogoutPage : function(entrySource){
        // entrySource 가 있을때만 호출
        try {
            if(entrySource){
                callLogEvent("로그아웃 클릭", { entry_source: entrySource, click_source:"로그아웃" } );
            }
        }catch (e) { void 0;}

        // 로그아웃 시 linkageString 제거
        document.cookie = "linkageString=;path=/;expire=0;max-age=0";

        localStorage.removeItem("setTrackEvent");
        //로그아웃
        /* 3200210  큐레이션 개선 관련 건-레코벨 데이터 송부
         * 로그인 유저에 한해서 피부정보 조회(동의여부 기반 조회)
         * 중복 호출을 막기 위해, localStorage 사용.
         * updateSkinYn은 '프로필-나의 피부 컨디션 정보 변경 시, N으로 변경되며, 'N'에 해당 경우에만 DB를 호출하도록 변경
         * 로그아웃 시에는 localStorage에서 제거
        */
        if (localStorage)
            localStorage.removeItem("updateSkinYn");

        /* 3212592 12월올영세일_온라인몰 특이현상 점검 및 개선 요청의 件
         * "login/loginCheckJson.do" 중복 호출을 막기 위한 SessionStorage내, checkLoginStatus등록
         * 만약 checkLoginStatus내에 값이 존재할 경우, 값을 반환한다.
         * 로그 아웃일 경우,  SessionStorage내, checkLoginStatus를 제거한다.
         */
        sessionStorage.removeItem("checkLoginStatus");
        /**
         * [CJOYMS-626] 다른 계정으로 로그인 시 바로 전 로그인 되었던 유저의 배송지 목록이 표시 되는 오류 제거
         */
        sessionStorage.removeItem('todayDeliveryAddressList');

        // [CJOYCOMD-1722] 검증용 임시: logout.do 발화원 진단 서명(d=mlp/es/lc) — 서버 미소비 파라미터, 운영 반영 전 제거 대상
        window.location.replace(_secureUrl + "login/logout.do?d=mlp&es=" + encodeURIComponent(entrySource || 'na') + "&lc=" + encodeURIComponent(window.__oyDiagLc ? window.__oyDiagLc() : 'nf'));
    },

    /**
     * 장바구니 페이지 이동
     */
    moveCartPage : function(amplitudeParamString){
        var cartPageUrl = _secureUrl + "cart/getCart.do";
        var quickYn = common.getCookie('moveO2oCartYn');
        var queryParams = [];

        if(!common.isEmpty(quickYn)) {
            queryParams.push("quickYn=" + quickYn);
        }

        if(!common.isEmpty(amplitudeParamString)) {
            queryParams.push(amplitudeParamString);
        }

        if(!common.isEmpty(queryParams)) {
            cartPageUrl += "?" + queryParams.join("&");
        }

        location.href = cartPageUrl;
    },

    /**
     * 주문배송목록 페이지 이동
     */
    moveOrderList : function(){
        location.href = _secureUrl + "mypage/getOrderList.do";
    },

    /**
     * 새 페이지 이동 공통 진입점.
     * 앱 3.51.0 이상: 네이티브 새 웹뷰(nativeScreen.pushScreen)로 띄움.
     * 그 외(웹/구버전): fallback 실행(기본 location.href).
     */
    openScreen : function(url, fallback){
        if (common.app.nativeScreen.isSupported() && common.app.nativeScreen.pushScreen(url)) {
            return;
        }
        if (typeof fallback === "function") {
            fallback();
        } else {
            location.href = url;
        }
    },

    /**
     * 뒤로가기 공통 진입점.
     * 앱 3.51.0 이상: nativeScreen.goBack() (대상 없으면 네이티브가 pop)
     * 그 외: fallback 실행(기본 history.back())
     */
    goBackScreen : function(fallback){
        if (common.app.nativeScreen.isSupported() && common.app.nativeScreen.goBack()) {
            return;
        }
        if (typeof fallback === "function") {
            fallback();
        } else {
            history.back();
        }
    },

    /**
     * 고객센터 메인 페이지 이동
     */
    moveCounselMain : function(){
        var trackingParam = getEventParameterString({
            t_page: "푸터",
            t_click: "푸터_고객센터"
        });
        var url = _plainUrl + "counsel/main.do?"+trackingParam;
        common.link.openScreen(url, function(){ location.href = url; });
    },

    /**
     * 매장안내 메인 페이지 이동
     */
    moveStoreMain : function(){
        location.href = _plainUrl + "store/getStoreMain.do?trackingCd=Store_Recommend_Best";
    },

    /**
     * 공지 이동
     * 관심매장  : 02
     */
    moveNtcList : function(ntcClssCd) {
        if (ntcClssCd == undefined) {
            ntcClssCd = "";
        }
        location.href = _plainUrl + "counsel/getNoticeList.do?ntcClssCd=" + ntcClssCd;
    },

    /**
     * 공지 상세
     */
    moveNtcDetail : function(ntcClssCd, ntcSeq) {
        if (ntcClssCd == undefined) {
            ntcClssCd = "";
        }
        if (ntcSeq == undefined) {
            ntcSeq = "";
        }
        location.href = _plainUrl + "counsel/getNoticeDetail.do?ntcSeq=" + ntcSeq + "&ntcClssCd=" + ntcClssCd;
    },

    /**
     * 검색 메인 이동
     */
    moveSearchMain : function() {

        alert("검색메인 작업 후 redirect 처리예정.");
        return;
    },

    /**
     * 앱 푸시 알림 목록 이동
     */
    moveAppPushHistList : function() {

        // 반복적 클릭 방지
        var _link = $(".intro").find("a.notice");

        _link.attr("href", "javascript:;");

        setTimeout(function() {
            _link.attr("href", "javascript:common.link.moveAppPushHistList();");
        }, 3000);

        // 알림함 접근 허용 여부 flag (CJOYMS-2625 티켓 완료 후 로직 제거)
        common.Ajax.sendRequest(
            "GET",
            _baseUrl + "push/api/v1/pushes/useFlag",
            null,
            function (res) {
                if (!res.data) {
                    alert("더 나은 알림함을 만들기 위해 작업 중이에요!\n잠시 후 이용해 주세요.\n\n(작업시간 : 01:00~03:00)");
                } else {
                    // 앱 버전 체크 위해 파라미터 추가
                    var param = "";
                    if (common.app.appInfo.isapp) {
                        var osType  = common.app.appInfo.ostype;
                        var appVer = common.app.appInfo.appver.replace(/\./gi, "");
                        param = "?osType="+osType+"&appVer="+appVer;
                    }

                    var amplitudeParams = "";
                    try {
                        amplitudeParams = (param.length > 0 ? "&" : "?" )+ getEventParameterString({t_page: '마이페이지' , t_click:'알림함'});
                        callLogEvent("마이페이지_알림클릭",  {entry_source: '마이페이지', click_source: '알림'});
                    }catch (e) { void 0;}
                    location.href = _plainUrl + "push/getAppPushHistList.do"+param+amplitudeParams;
                }
            },
        )
    },

    /**
     * 개인정보 처리방침 팝업
     */
    callPrivacyPage : function (){
      // 앱일 경우 스택스크린으로 오픈된다.
      location.href = _baseUrl + "company/privacy.do";
    },

    /**
     * 위치정보 처리방침 팝업
     */
    callLocationPolicyPage : function (){
      // 앱일 경우 스택스크린으로 오픈된다.
      location.href = _baseUrl + "mtn/terms/location";
    },

    /**
     * 개인정보 처리방침 팝업 컨텐츠 생성
     */
    callBackPrivacyPage : function (strData){
        $("#pop-full-title").text("개인정보 처리방침");
        $("#pop-full-contents").empty().append(strData);
        common.setScrollPos();
        common.popFullOpen("개인정보 처리방침", "");
    },

    /**
     * 이용약관 팝업
     */
    callTermsPage : function (){
      // 앱일 경우 스택스크린으로 오픈된다.
      location.href = _baseUrl + "mtn/terms/service"
    },

    /**
     * 이용약관 팝업 컨텐츠 생성
     */
    callBackTermsPage : function (strData){
        $("#pop-full-title").text("이용약관");
        $("#pop-full-contents").empty().append(strData);
        common.setScrollPos();
        common.popFullOpen("이용약관", "");
    },

    /**
     * 법적고지 팝업
     */
    callLegalPage : function (){
        common.Ajax.sendRequest("POST"
                , _baseUrl + "company/legalAjax.do"
                , null
                , common.link.callBackLegalPage
        );
    },

    /**
     * 법적고지 팝업 컨텐츠 생성
     */
    callBackLegalPage : function (strData){
        $("#pop-full-title").text("법적고지");
        $("#pop-full-contents").empty().append(strData);
        common.setScrollPos();
        common.popFullOpen("법적고지", "");
    },

    /**
     * 청소년 보호 방침 팝업
     */
    callYouthProtectionPage : function (){
      // 앱일 경우 스택스크린으로 오픈된다.
      location.href = _baseUrl + "mtn/terms/youth";
    },

    /**
     * 청소년 보호 방침 팝업 컨텐츠 생성
     */
    callBackYouthProtectionPage : function (strData){
        $("#pop-full-title").text("청소년 보호 방침");
        $("#pop-full-contents").empty().append(strData);
        common.setScrollPos();
        common.popFullOpen("청소년 보호 방침", "");
    },

    /**
     * 이메일 무단 수집 거부 팝업
     */
    callDenyEmailPage : function (){
        common.Ajax.sendRequest("POST"
                , _baseUrl + "company/denyEmailAjax.do"
                , null
                , common.link.callBackDenyEmailPage
        );
    },

    /**
     * 이메일 무단 수집 거부 컨텐츠 생성
     */
    callBackDenyEmailPage : function (strData){
        $("#pop-full-title").text("이메일 무단 수집 거부");
        $("#pop-full-contents").empty().append(strData);
        common.setScrollPos();
        common.popFullOpen("이메일 무단 수집 거부", "");
    },

    /**
     * 영상정보처리기기 운영/관리 방침 팝업
     */
    callMultimediaPage : function (){
        common.Ajax.sendRequest("POST"
                , _baseUrl + "company/multimediaAjax.do"
                , null
                , common.link.callBackMultimediaPage
        );
    },

    /**
     * 영상정보처리기기 운영/관리 방침 생성
     */
    callBackMultimediaPage : function (strData){
        $("#pop-full-title").text("영상정보처리기기 운영/관리 방침");
        $("#pop-full-contents").empty().append(strData);
        common.setScrollPos();
        common.popFullOpen("영상정보처리기기 운영/관리 방침", "");
    },

    /**
     * 법적고지 팝업
     */
    callLegalFooterPage : function (){
      location.href = _baseUrl + "mtn/terms/legal";
    },
    /**
     * 대량구매
     */
    callBulkPurchase: function (){
        const eventProperties = {
            entry_source: "푸터",
            click_source: "푸터_대량구매"
        }

        callLogEvent("푸터_대량구매 클릭", eventProperties);
    },

    /**
     * 법적고지 팝업 컨텐츠 생성
     */
    callBackLegalFooterPage : function (strData){
        $("#pop-full-title").text("법적고지");
        $("#pop-full-contents").empty().append(strData);
        common.setScrollPos();
        common.popFullOpen("법적고지", "");
    },

    /**
     * 개인정보 수집 및 활용 동의(필수)
     */
    callPrivacyTermPage : function (){
        common.Ajax.sendRequest("POST"
                , _baseUrl + "company/privacyTermAjax.do"
                , null
                , common.link.callBackPrivacyTermPage
        );
    },

    /**
     * 개인정보 수집 및 활용 동의(필수)
     */
    callBackPrivacyTermPage : function (strData){
        $("#pop-full-title").text("개인정보 수집 및 활용 동의(필수)");
        $("#pop-full-contents").empty().append(strData);
        common.setScrollPos();
        common.popFullOpen("개인정보 수집 및 활용 동의(필수)", "");
    },

    /**
     * 20191101. 올리브영 3자동의(필수) 추가
     */
    callOyThirdTermPage : function (){
        common.Ajax.sendRequest("POST"
                , _baseUrl + "company/oyThirdTermAjax.do"
                , null
                , common.link.callBackOyThirdTermPage
        );
    },

    /**
     * 20191101. 올리브영 3자동의(필수) 콜백 추가
     */
    callBackOyThirdTermPage : function (strData){
        $("#pop-full-title").text("올리브영 제3자제공 동의");
        $("#pop-full-contents").empty().append(strData);
        common.setScrollPos();
        common.popFullOpen("올리브영 제3자제공 동의", "");
    },

    /**
     * 20191101. CJ ONE 3자동의(필수) 추가
     */
    callCjoneThirdTermPage : function (){
        common.Ajax.sendRequest("POST"
                , _baseUrl + "company/cjoneThirdTermAjax.do"
                , null
                , common.link.callBackOyThirdTermPage
        );
    },

    /**
     * 20191101. CJ ONE 3자동의(필수) 콜백 추가
     */
    callBackCjoneThirdTermPage : function (strData){
        $("#pop-full-title").text("CJ ONE 제3자제공 동의");
        $("#pop-full-contents").empty().append(strData);
        common.setScrollPos();
        common.popFullOpen("CJ ONE 제3자제공 동의", "");
    },

    /**
     * 개인정보 수집 및 활용 동의(선택)
     */
    callPrivacyTermOptPage : function (){
        common.Ajax.sendRequest("POST"
                , _baseUrl + "company/privacyTermOptAjax.do"
                , null
                , common.link.callBackPrivacyTermOptPage
        );
    },

    /**
     * 개인정보 수집 및 활용 동의(필수)
     */
    callBackPrivacyTermOptPage : function (strData){
        $("#pop-full-title").text("개인정보 수집 및 활용 동의(선택)");
        $("#pop-full-contents").empty().append(strData);
        common.setScrollPos();
        common.popFullOpen("개인정보 수집 및 활용 동의(선택)", "");
    },

    /**
     * 위치정보 이용 약관(선택) 페이지 호출
     */
    callLocationTermsOptPage : function (){
        common.Ajax.sendRequest("POST"
            , _baseUrl + "company/locationTermsOptAjax.do"
            , null
            , common.link.callBackLocationTermsOptPage
        );
    },

    /**
     * 위치정보 이용 약관(선택)
    * */
    callBackLocationTermsOptPage: function (strData) {
        $("#pop-full-title").text("위치기반서비스 이용약관");
        $("#pop-full-contents").empty().append(strData);

        common.unlockBody(); // 스크롤 해제
        common.setScrollPos();
        common.popFullOpen("위치기반서비스 이용약관", function () {
            // 모달 팝업 노출 아닐때는 스크롤을 막지 않음.
            if(!$("#locationPop").hasClass("on")){
                return;
            }

            // 하단바 숨김
            $("#footerTab").removeClass("on");

            if(common.app.appInfo.isapp)
                common.footer.setNativeTabBarVisibility(false);

            common.lockBody(); // 스크롤 멈춤
        });
    },

    /**
     * 오픈 라이선스 페이지 호출
     */
    callOpenLicensePage : function (){
        common.Ajax.sendRequest("POST"
            , _baseUrl + "common/openLicense.do"
            , null
            , common.link.openLicensePage
        );
    },

    /**
     * 오픈 라이선스
     * */
    openLicensePage: function (strData) {
        $("#pop-full-title").text("오픈 라이선스");
        $("#pop-full-contents").empty().append(strData);
        common.unlockBody(); // 스크롤 해제
        common.setScrollPos();
        common.popFullOpen("오픈 라이선스", function () {
            // 하단바 숨김
            $("#footerTab").removeClass("on");
            common.footer.setNativeTabBarVisibility(false);
            common.lockBody(); // 스크롤 멈춤
        });
    },

    /**
     * 이벤트 상세 페이지 이동
     */
    moveEventDetailPage : function (evtNo, amplitudeParamString){
        if (amplitudeParamString) {
            location.href = _plainUrl + "event/getEventDetail.do?evtNo="+evtNo+amplitudeParamString;
        } else {
            location.href = _plainUrl + "event/getEventDetail.do?evtNo="+evtNo;
        }
    },

    /**
     * 뷰티테스터 상세 페이지 이동
     */
    moveBeautyDetailPage : function(evtNo) {
        location.href = _plainUrl + "beauty/getBeautyDetail.do?evtNo="+evtNo;
    },

    /**
     * 매장안내 상세 페이지 이동
     */
    moveStoreDetailPage : function(strNo, dist, openYn) {
        location.href = _plainUrl + "store/getStoreDetail.do?strNo="+strNo+"&dist="+dist+"&openYn="+openYn;
    },

    /**
     * 마이 뷰티리스트 페이지 이동
     */
    moveMyBeautyListPage : function(searchMonth,startDate,endDate) {
        location.href = _plainUrl + "mypage/getMyBeautyList.do?searchMonth="+searchMonth+"&startDate="+startDate + "&endDate="+endDate;
    },

    /**
     * 마이 이벤트리트스 페이지 이동
     */
    moveMyEventListPage : function(searchMonth,startDate,endDate) {
        location.href = _plainUrl + "mypage/getMyEventList.do?searchMonth="+searchMonth+"&startDate="+startDate + "&endDate="+endDate;
    },


    /**
     * 마이 페이지 배송지 수정
     */
    moveMyDeliveryInfoPage : function() {
        // 배송지 등록시 생기는 환경변수 제거
        sessionStorage.removeItem("regDeliveryYn");

        location.href = _plainUrl + "mypage/getDeliveryInfo.do";
    },

    /**
     * 올리브영 멤버쉽 페이지로 이동
     */
    moveMyMembershipInfoPage : function() {
        location.href = _plainUrl + "customer/getMembershipInfo.do";
    },

    /**
     * 공정거래위원회>정보공개>사업자등록현황>통신판매사업자>상세조회화면 으로 이동
     * SR[3465376] 푸터 사업자정보확인
     */
    openFtcBizInfo : function() {
        common.app.callOpenWebScreen({
            title: "사업자정보확인",
            url: "https://www.ftc.go.kr/bizCommPop.do?wrkr_no=8098101574",
            closeYn: "N",
            isGet: "N",
            isBack: "N",
            method: "get",
        })
    },

    /**
     * LGU+ 에스크로
     */
    openLGUPEscrow : function() {
        common.app.callOpenPage("LG U+ 구매안전서비스","https://pgweb.uplus.co.kr/ms/escrow/s_escrowYn.do?mertid=CJS31","N","N","N");
    },

    openEscrowPopup : function(url) {
        common.app.callOpenWebScreen({
            title: "하나은행 구매안전 서비스",
            url,
            closeYn: "N",
            isGet: "Y",
            isBack: "N",
            method: "get",
        })
    },

    /**
     * 사이버감사실
     */
    openCyberAudit : function() {
        common.app.callOpenPage("사이버 감사실","https://ethics.cj.net/whistles/information","N","Y","N");
        //location.href = _plainUrl + "prvsuser/getCjaudit.do";
    },

    /**
     * 마이 뷰티리스트 페이지 후기작성이동
     */
    moveMyBeautyWritePage : function(evtNo,goodsNo,retUrl) {
        location.href = _plainUrl + "mypage/getGdasEvalForm.do?evtNo="+evtNo+"&goodsNo="+goodsNo+"&gdasTpCd=30&gdasSctCd=30&gdasSeq=&gdasStep=1&retUrl="+retUrl;
    },

    /**
     * 마이 회원정보수정 이동
     */
    moveMemberInfoChangePage : function(amplitudeParamString) {
        location.href = _plainUrl + "mypage/getMemberInfoChangeForm.do"+ (amplitudeParamString ? ("?"+amplitudeParamString) : "");
    },

    /**
     * 마이페이지 > 설정 > 마켓팅 활용동의 수신 변경
     * appVersion 3.9.0 미만에서는 drawer 또는 회원정보 수정으로 이동
     * appVersion 3.9.0 이상에서는 개편된 알림설정 페이지로 이동.
     * @param amplitudeParamString 앰플리튜드 파라미터 String 값
     *  ex) t_page=마이페이지_리뷰&t_click=체험단탭_띠배너
     * @param useCallSettings 앱 드로워 설정 오픈 true | 마이페이지 수정 오픈 false
     * */
    moveSettingAtPush : function (amplitudeParamString, useCallSettings){
        try{
            if(common.app.appInfo.isapp && common.app.compareVersion(common.app.appInfo.appver, "3.9.0") ==  "<"){
                // 앱이고 3.9.0 이하 버전
                if(useCallSettings){
                    common.app.callSettings();
                }else{
                    this.moveMemberInfoChangePage(amplitudeParamString);
                }
            }else{
                // 앱이 아님 , 앱이고 3.9.0 위 버전
                if(JSON.parse(sessionStorage.getItem("useNewSetting")) === false){
                    this.moveMemberInfoChangePage(amplitudeParamString);
                }else{
                    location.href = '/m/mtn/setting/push'+"?"+amplitudeParamString;
                }
            }
        }catch (e) {
            // 에러났을 경우 그냥 기존 페이지로 이동
            void 0;
            this.moveMemberInfoChangePage(amplitudeParamString);
        }
    },

    /**
     * 1:1문의 리스트 이동
     */
    moveCounselListPage : function(selectedForm) {
        var param = "";
        if (selectedForm != undefined && selectedForm) {
            param = "?idx=qnaForm";
        }
        location.href = _plainUrl + "counsel/getQnaForm.do" + param;
    },
    moveCounselListFooter : function(selectedForm) {
        var param = "";
        if (selectedForm != undefined && selectedForm) {
            param = "?idx=qnaForm";
        }
        var trackingParam = getEventParameterString({
            t_page: "푸터",
            t_click: "푸터_1:1문의"
        });
        var url = _plainUrl + "counsel/getQnaForm.do" + param +"&"+ trackingParam;
        common.link.openScreen(url, function(){ location.href = url; });
    },
    /**
     * 상품상세 탭으로 이동(리뷰베스트에서 상품 상세 이동시 앵커 처리를 위해 프론트에서 가져옴)
     * trackingCd 변수 추가 - [3389141] (영역별 매출분석) 오특, 검색, 베스트, 메인 추가(CHY)
     */
    moveGoodsDetailTab : function(goodsNo , dispCatNo, moveTab, trackingCd) {
        var param = "?goodsNo=" + goodsNo;
        if (!common.isEmpty(dispCatNo)) {
            param = param + "&dispCatNo=" + dispCatNo;
        }

        if (!common.isEmpty(trackingCd)) {
            param = param + "&trackingCd=" + trackingCd;
        }

        sessionStorage.setItem("moveTab", moveTab);
        location.href = _plainUrl + "goods/getGoodsDetail.do" + param;
    },

    // 앱스택스크린 관련 스크립트
    appStackScreen: {
        /**
         * 새로운 스크린 추가 시 관련 내용 추가 필요
         * screenUrl : 구분할 스크린 URL 패턴
         * appVersion : 앱스택스크린 적용 체크할 앱 버전
         * type : 스크린 타입
         * screenUrlParam : 파라미터(optional)
         * customFunction : 각 스크린 타입마다 필요한 커스텀 함수 추가
         */
        screenType: [
            // W CARE 앱스택스크린
            {
                screenUrl: "mtn/wcare",
                appVersion: "3.3.0",
                type: "wcare",
                screenUrlParam: "",
                customFunction: {
                    makeUrlParam: function (url, screenType) {
                        // 진입 URL에 따라서 메인 앱스택스크린을 우선 띄우고 이동될 앱스택스크린 페이지 관련 파라미터 추가
                        if (url.indexOf("intro") > 0) {
                            url = url.replace("/intro", "")
                            screenType.screenUrlParam = "type=home&toIntro=true";
                        }
                        else if (url.indexOf("join") > 0) {
                            url = url.replace("/join/step1", "")
                            screenType.screenUrlParam = "type=home&toJoin=true";
                        }
                        else {
                            screenType.screenUrlParam = "type=home";
                        }

                        return url
                    }
                }
            },

            // 설정 페이지 앱스택스크린
            {
                screenUrl: "mtn/setting",
                appVersion: "3.9.0",
                type: "setting",
                screenUrlParam: "",
                customFunction: {
                }
            }
        ],
        // 앱스택스크린 스크린타입에 따른 URL 생성
        makeUrl: function(url, screenType) {
            // W CARE인 경우 진입 Url Param 생성
            if (screenType.type == "wcare") {
                // W CARE screenUrlParam 추가
                url = screenType.customFunction.makeUrlParam(url, screenType);
            }

            // screenUrlParam 있는 경우 파라미터 세팅
            if (!common.isEmpty(screenType.screenUrlParam)) {
                if (url.indexOf("?") == -1) {
                    url = url + "?" + screenType.screenUrlParam;
                }
                else {
                    url = url + "&" + screenType.screenUrlParam;
                }
            }

            return encodeURIComponent(_plainUrl + url);
        },
        // 앱스택스크린 이동
        movePage: function(url, screenType) {
            // 앱스택스크린 스크린타입별 앱 버전 체크
            if (common.app.appInfo.isapp && common.app.compareVersion(common.app.appInfo.appver, screenType.appVersion) !=  "<") {
                // 앱 스택스크린 페이지 이동의 경우 로딩바가 사라지지 않아 별도 비노출 처리
                common.hideLoadingLayer();

                location.href = "olivescreen://" + screenType.type + "?url=" + this.makeUrl(url, screenType);

                return true;
            }

            location.href = _plainUrl + url;

            return true;
        },
        // 앱스택스크린 호출
        call: function(url){
            for(var i = 0 ; i < this.screenType.length ; i++) {
                // 앱스택스크린 적용 URL인 경우 앱스택스크린 페이지 이동
                if (url.indexOf(this.screenType[i].screenUrl) >= 0) {
                    // url 내 /m이 중복으로 들어 경우를 방지하여 substring 사용
                    url = url.substring(url.indexOf(this.screenType[i].screenUrl));

                    return this.movePage(url, this.screenType[i]);
                }
            }

            return false;
        },

        member:{
            /**
             * cntReload
             * 로드를 반복해서 하지 않기 위한 변수
             * */
            _cntReload: 0,
            /**
             * reloadIfLogoin
             * 로그아웃 로직이 포함되어 있어, 로그인 정보가 없을 수 있을때 호출.
             * */
            reloadIfLogoin: function (){
                if(!common.getCookie('linkageString')){
                    void 0;
                    this._reload();
                }
            },
            /**
             * reloadAfterDeleteOyPay
             * 간편결제 해지 되었을 때 호출
             * */
            reloadAfterDeleteOyPay: function (){
                void 0;
                this._reload();
            },
            /**
             * 내부 페이지 리로드 스크립트
             * */
            _reload: function () {
                // 리로드를 한번이라도 호출 했다면 리로드 하지 않고 처리
                if(this._cntReload > 0) return;

                this._cntReload++;
                location.reload();
            }
        }
    },

    /**
     * 본인인증 페이지 경로.
     */
    CERT_URL_PATH : "customer/regCertification.do",

    /**
     * PIN 본인인증 페이지로 이동한다.
     * 앱은 현재 웹뷰를 덮으면 인증 완료 후 원래 페이지로 복귀할 수 없으므로 네이티브 새 화면으로 띄운다.
     */
    movePinCertUrl : function(url) {
        if (!common.isLoginForEvt()) {
            this.moveLoginPage();
            return;
        }

        if (common.app.appInfo && common.app.appInfo.isapp) {
            // 앱: 네이티브 새 화면으로 띄우면 기획전이 스택에 남아, PIN 설정 완료 후 callClosePopup으로 복귀한다.
            // commonMoveUrl은 _plainUrl 기준 상대경로를 받지만 인증 페이지는 _secureUrl로 진입해야 한다.
            common.app.callOpenPage("올리브영 PIN 번호 설정",
                _secureUrl + url.substring(url.indexOf(this.CERT_URL_PATH)), "N", "N", "N");
            return;
        }

        // 모웹: 현재 창이 덮여 닫을 화면이 없으므로 복귀 대상을 넘겨야 한다.
        // setup.do가 returnUrl을 세션에 저장한 뒤 본인인증으로 보내고, PIN 설정 완료 후 그 경로로 돌아온다.
        location.href = _secureUrl + "oy-pin/setup.do?returnUrl=/"
            + location.pathname.split("/").slice(2).join("/");
    },

    /**
     * 공통 URL 이동 ( CONTEXT 이후의 URL로 이동하기 )
     */
    commonMoveUrl : function(url){
        // PIN 본인인증은 진입 방식(앱 네이티브 화면)과 베이스 URL이 달라 movePinCertUrl에 위임한다
        if (url.indexOf(this.CERT_URL_PATH) >= 0 && url.indexOf("pinYn=Y") >= 0) {
            this.movePinCertUrl(url);
            return;
        }

    	// trackingCd 변수 추가 - [3389141] (영역별 매출분석) 오특, 검색, 베스트, 메인 추가(CHY)
    	var trackingCd = $(".planBanner").attr("name");

    	if(!common.isEmpty(trackingCd) && url.indexOf("?") != -1){
    		url = url + "&trackingCd=" + trackingCd;
    	}else if(!common.isEmpty(trackingCd) && url.indexOf("?") == -1){
    		url = url + "?trackingCd=" + trackingCd;
    	}

        // 앱스택스크린이 적용이 되어있을 경우 앱스택스크린 페이지 전환 방식으로 이동
        if (!this.appStackScreen.call(url)) {
            location.href = _plainUrl + url;
        }
    },

    /**
     * 오늘드림 테마리스트 URL
     */
    moveQuickListUrl : function(themeNo, themeNm, themeType, trackingCd) {
        location.href = _plainUrl + "quick/getMOQuickList.do?themeNo="+themeNo+"&themeNm="+themeNm+"&dispCatNo="+themeNo+"&themeType="+themeType + (trackingCd ? '&trackingCd=' + trackingCd : '');
    },

    /**
     * 카테고리관으로 이동 - 카테고리관 추가 ( 2020.07.01 )
     */
    moveCategoryShop : function(dispCatNo, gateCd) {
        location.href = _plainUrl + "display/getCategoryShop.do?dispCatNo=" + dispCatNo + (gateCd ? '&gateCd='+gateCd : '');
    },

    /**
     * 설문 온라인몰 연동
     */
    openCampSurvey : function(res) {
    	var modifyEvtCampLinkUrl = res.evtCampLinkUrl;
    	common.app.callOpenPage(" ",modifyEvtCampLinkUrl,"N","Y","N");
    },

    /**
     * 사이버감사실2
     */
    openCyberAudit2 : function() {
        window.open("https://ethics.cj.net/whistles/information");

        common.oyLayerClose('cyberAuditPop');
        //location.href = _plainUrl + "prvsuser/getCjaudit.do";
    },

    /**
     * App Download 페이지로 이동합니다.
     */
    openAppDownloadPage : function() {
        var userAgent = navigator.userAgent.toLowerCase();

        var ANDROID_APP_DOWNLOAD_URL = "https://play.google.com/store/apps/details?id=com.oliveyoung&hl=ko";
        var IOS_APP_DOWNLOAD_URL = "https://itunes.apple.com/kr/app/id873779010?l=kr&mt=8";

        if(userAgent.match(/android/)){
            window.open(ANDROID_APP_DOWNLOAD_URL);
        } else if(userAgent.match(/iphone|ipad|ipod/)){
            window.open(IOS_APP_DOWNLOAD_URL);
        }
        callLogEvent('앱_다운로드',getParameterFromObject({
            't_page':'쿠폰혜택',
            't_click':'올리브영앱다운로드'
        }));
    },
};
